module.exports = __webpack_public_path__ + "static/media/icon_vector.beb0d321.svg";